import React, { useEffect, useState } from 'react';
import Loader from './common/Loader';
import { useFetchStaticData } from './data/fetchStaticData';
import { loadXSportDatastoreStaticResources } from './data/sport-utils';
import { getBetradarStreamingProps } from './data/streaming/streamingUtils';
import { unmappedMarkets } from './data/unmapped-markets';
import { getConfiguration } from './data/utils/configuration';
import { loadLanguage } from './data/utils/loadLanguage';
import { handleMenuItems, handleMenuLabels } from './utils/sport-effects';
import { isScriptGDPRCompliant } from './data/gdpr-utils';
import { labels } from './data/labels';
import { initAppConfig } from './appConfig';

initAppConfig();

// export const appConfig = {
//     "PUBLIC_URL":process.env.PUBLIC_URL,
//     "basename":(window.appConfig||null)===null?process.env.PUBLIC_URL:window.appConfig.BASENAME,
//     ...((window.appConfig||null)===null?require(`./config/${process.env.REACT_APP_XSPORT_CUSTOMER}.conf.json`):window.appConfig)

// }

// appConfig.ROUTES.sectionFromPath = function(path,sections){
//    return Object.keys(sections).find(function(k){return sections[k]===path || sections[k] === [path,'/'].join('')  });
// }

// appConfig.ROUTES.pathFromSection = function(route,section){
//     return appConfig.ROUTES[route][section]
//  }

// appConfig.ROUTES.routeFromPath = function(path){
//     var toReturn = null;
//     //console.log('--->'+path)
//     path && Object.entries(appConfig.ROUTES).forEach(function([k,v])
//     {
       
       
//         if(!(typeof v =='function')){
//            if(Object.keys(v).find(function(k2){return v[k2]==path || v[k2] == [path,'/'].join('') })){
//                 //console.log('aaa'+k)
//                 toReturn =  k;
//            }
//         }
//     });
//     return toReturn;
// }

function loadScriptsFromDataConfig() {
    const apiDomain = process.env.REACT_APP_API_DOMAIN;
    const warName = process.env.REACT_APP_WAR_NAME? process.env.REACT_APP_WAR_NAME : 'XSportDatastore';
    const xs_languageCode = loadLanguage();
    const scriptUrls = [];
    const cssHrefs = []
    const configuration = getConfiguration();
    try {
        let widgetURL = configuration['ps']['lte']['BETRADAR_WIDGET']?.['ujs']?.['ALL'] ?? null;
        if (widgetURL!= null) {
            widgetURL = widgetURL.replace('{{lang}}', xs_languageCode.toLowerCase());
            scriptUrls.push(widgetURL);
        }
        const streamingRadar = getBetradarStreamingProps();
        if (streamingRadar) {
            scriptUrls.push(`${apiDomain}/${warName}/content/js/streaming/avvpl-player.js`);
            cssHrefs.push(`${apiDomain}/${warName}/content/js/streaming/style/styles.css`);
        }
  
    } catch(err) {
      console.log(err);
    }
  
    cssHrefs.forEach(function(h) {
        var lnk = document.querySelectorAll(`link[href="${h}"]`);
        if (!lnk.length) {
            var css = document.createElement('link');
            css.setAttribute("rel", "stylesheet")
            css.setAttribute('href', h);
            document.head.appendChild(css);
        }
    });
  
    scriptUrls.forEach(function(s) {
        if(isScriptGDPRCompliant(s)){
            var scr = document.querySelectorAll(`script[src="${s}"]`);
            if (!scr.length) {
                var script = document.createElement('script');
                script.setAttribute('src', s);
                document.head.appendChild(script);
            }
        }
    });
}

function InitData(props) {
    // window.appConfig = appConfig;
    // window.blockHistoryChanges = function(){
    //     return window.appConfig?.SHOP_MODE;
    // }
    // appConfig.BASENAME = (window.appConfig == null) ? process.env.PUBLIC_URL : window.appConfig.BASENAME;
    const [onInitState,setOnInitState] = useState(false);

    if (window.xs_ag === undefined) {
        window.xs_ag = {
            betById: {},
            aggregatePrematchBySportId: {},
            aggregateLiveByIdSport: {},
            agsByBetId : {},
            agsByBetIdAndSportId : {}
        };
    }
    const [state] = useFetchStaticData();

    useEffect(() => {
        window.whenJqueryLoaded(function () {
            handleMenuItems();
        });
    }, []);

    if (state.isLoading || state.isError) {
        return <Loader error={state.isError} />;
    }

    if (!onInitState) {
        loadXSportDatastoreStaticResources(true);
        loadScriptsFromDataConfig();

        const menuLabels = {
            'prematch': labels['menu.prematch'] || 'Prematch',
            'live': labels['menu.live']         || 'Live',
            'betslip': labels['menu.betslip']   || 'Betslip',
            'mybets': labels['menu.mybets']     || 'My Bets'
        };

        handleMenuLabels(menuLabels);
        unmappedMarkets.fetch();
        setOnInitState(true);
    }

    return (
        <>
            {props.children}
        </>
    );
}

export default InitData;